import subModuleKeys from '@/modules/constants/subModuleKeys';

const FacebookPixelModule = () => import(/* webpackChunkName: "facebookpixel" */ '@/components/modules/integrations/FacebookPixelModule');

const subModules = {
  [subModuleKeys.FACEBOOK_PIXEL]: {
    name: subModuleKeys.FACEBOOK_PIXEL,
    component: FacebookPixelModule,
    path: '/integrations/facebook/:eventId?',
    props: (route) => ({
      moduleKey: subModuleKeys.FACEBOOK_PIXEL,
      eventId: route
        ? parseInt(route.params.eventId, 10)
        : null,
    }),
  },
};

export default subModules;
